import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { ErrorStateComponent } from '@/components/error-state/error-state.component';
import { ErrorStateCode } from '@/components/error-state/error-state.type';
import { ErrorPageCode, errorPageCodeStateCode } from './error.type';
import { BreakpointService } from '@/services/breakpoint/breakpoint.service';

@Component({
  selector: '.error-page',
  imports: [ErrorStateComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  constructor() {
    this.#setCodeFromActivatedRoute();
  }

  #activatedRoute = inject(ActivatedRoute);
  #destroyRef = inject(DestroyRef);

  breakpointService = inject(BreakpointService);

  testId = signal('view-error').asReadonly();
  stateCode = signal<ErrorStateCode>('notFound');

  #setCodeFromActivatedRoute(): void {
    this.#activatedRoute.data
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        tap((data) => {
          const code = data['code'] as ErrorPageCode;

          this.stateCode.set(errorPageCodeStateCode[code]);
        }),
      )
      .subscribe();
  }
}
